// Core components
import { Component } from "@angular/core";

// Third party components
import { FieldArrayType } from "@ngx-formly/core";

// Custom components

/**
 * Script start
 */
@Component({
  selector: "formly-scale-repeat-section",
  templateUrl: "./repeat-scale-type.component.html",
  styleUrls: ["./repeat-scale-type.component.scss"]
})
export class RepeatScaleTypeComponent extends FieldArrayType {
}
